module.exports = __webpack_public_path__ + "img/nav-right-expand-search-lincoln.04b7620b.png";